import ComingSoon from "@/components/ComingSoon";

const PendingApprovalPage = () => {
  return <ComingSoon featureName="Pending Approval" description="Device and user approval workflows. This feature requires backend End-User Portal APIs." />;
};

export default PendingApprovalPage;
